import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    model: null
  },
  getters: {
    model: state => state.model
  },
  mutations: {
    setModel (state, model) {
      state.model = model
    }
  },
  action: {
    setModel (context, model) {
      context.commit('setModel', model)
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/model-store.js